import React, { useEffect, useState, useRef, useCallback } from "react";
import "./Distributor.css";
import logo from "../../assets/images/logo-black.svg";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  getWise_Stock_Report,
  getNegativeOtsOrderWise,
} from "../../redux/actions/wiseStockReport.action";
import { getProductType } from "../../redux/actions/productType.action";
import { ReadCookie } from "../../utils/readCookie";
import { Spin, Select, DatePicker, Checkbox, Form, Input } from "antd";
import { getStyle } from "../../redux/actions/style";
import { getGenderCategory } from "../../redux/actions/genderCategory.action";
import { getNewSeason } from "../../redux/actions/newSeason.action";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import { useDownloadExcel } from "react-export-table-to-excel";
import numeral, { Numeral } from "numeral";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import Loader from "react-spinners/BarLoader";
import { TabTitle } from "../../utils/GeneralFunction";
import { loadCustomers } from "../../redux/actions/customerForm";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";

const dateFormatList = ["MM-DD-YYYY"];

const NegativeOrderOtsWise2 = ({ token }) => {
  TabTitle("Negative OTS Order Wise");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    style,
    season,
    getWiseStockReport,
    productType,
    gender,
    productStatus,
    adminLocation,
    getNewSeasonReducer,
    customerForms,
    paymentterm,
    salePersonForm,
    NegativeOtsOrderWise,
  } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const [BGradechecked, setBGradeChecked] = useState(false);
  const [pendingDate, setpendingDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const [isChecked, setIsChecked] = useState([]);
  const [allSesion, setAllSesion] = useState(true);
  const [steps, setSteps] = useState([]);
  const stepsArr = [4, 17, 20, 99, 18, 3, 25, 29];
  const [pendingChecked, setPendingChecked] = useState(true);
  const [excelData, setExcelData] = useState([]);
  const [allStatus, setAllStatus] = useState(true);
  const [isChecked2, setIsChecked2] = useState([]);
  const [loadding, setLoadding] = useState(false);
  const [StockwiseReportData, setStockWiseReport] = useState([]);
  const initialDate = moment("2026-12-31");
  const [customer, setCustomer] = useState("All");
  const focusInput = useRef(null);
  const [adjustQuantities, setAdjustQuantities] = useState({
    qty8: 0,
    qty9: 0,
  });
  const tableRef = useRef(null);
  const buttonRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Negative OTS Order Wise",
    sheet: "Negative OTS Order Wise",
  });

  const customSortOrder = [
    "BERGEN WS",
    "BERGEN ECOM",
    "NORD D2C",
    "L&T D2C",
    "In Transit",
    "PK Warehouse W+W",
    "Production",
    "International",
  ];

  adminLocation?.payload?.data?.sort((a, b) => {
    const indexA = customSortOrder.indexOf(a.location_name);
    const indexB = customSortOrder.indexOf(b.location_name);
    return indexA - indexB;
  })

  useEffect(() => {
    if (adminLocation?.payload?.data?.length > 0) {
      setSteps(
        adminLocation?.payload?.data
          .filter((val) => stepsArr.includes(val.location_id))
          .map((it) => ({ ...it, selected: true }))
      );
    }
  }, [adminLocation]);

  const stepschecked =
    steps && steps?.filter((it) => it.selected)?.map((it) => it.location_id);

  const getStepData =
    adminLocation &&
    adminLocation?.payload?.data.filter((val) =>
      stepsArr.includes(val.location_id)
    );

  const [stepsChecked, setStepChecked] = useState([]);

  let result =
    StockwiseReportData &&
    StockwiseReportData.reduce(function (r, a) {
      r[a.item_code + a.inseam + a.description] =
        r[a.item_code + a.inseam + a.description] || [];
      r[a.item_code + a.inseam + a.description].push(a);
      return r;
    }, Object.create(null));

  const wiseStockReport = result && Object.values(result);

  const { Option } = Select;

  const onChangeDate = (date, dateString) => {
    setpendingDate(dateString);
  };

  const onChangeCheckBox = (e) => {
    setBGradeChecked(e.target.checked);
  };

  const handlePendingOrder = (e) => {
    setPendingChecked(e.target.checked);
  };

  const sesionSelectAll = (e) => {
    setAllSesion(e.target.checked);
  };

  const statusSelectAll = (e) => {
    setAllStatus(e.target.checked);
  };

  const isCheckboxChecked = (id, value) => {
    const filterCheckBox =
      getNewSeasonReducer &&
      getNewSeasonReducer?.payload?.data.find((val) => val.season_id === id);
    const checkId = isChecked.includes(id);
    if (!checkId) {
      setIsChecked((current) => [...current, filterCheckBox.season_id]);
    }

    if (!value) {
      const removeUnCheck = isChecked.filter(
        (item) => item !== filterCheckBox.season_id
      );
      setIsChecked(removeUnCheck);
    }

    setAllSesion(false);
  };

  const isCheckboxChecked2 = (id, value) => {
    const filterCheckBox =
      productStatus &&
      productStatus?.payload?.data.find((val) => val.product_status_id === id);
    const checkId = isChecked2.includes(id);
    if (!checkId) {
      setIsChecked2((current) => [
        ...current,
        filterCheckBox.product_status_id,
      ]);
    }
    if (!value) {
      const removeUnCheck = isChecked2.filter(
        (item) => item !== filterCheckBox.product_status_id
      );
      setIsChecked2(removeUnCheck);
    }
    setAllStatus(false);
  };

  const onFinish = async (e) => {
    await form.validateFields().then((values) => {
      values.BGradeStock = BGradechecked;
      values.stepsChecked = stepsChecked;
      values.isChecked = isChecked;
      values.isChecked2 = isChecked2;

      if (allStatus) {
        values.allStatus = allStatus;
      }

      if (pendingChecked) {
        stepschecked.push(-1);
      }

      const styleId =
        style &&
        style?.payload?.data.find((val) => val.style_name === values.style);

      const productStatusId =
        productStatus &&
        productStatus?.payload?.data.find(
          (val) => val.product_status_name === values.product_Status
        );

      const distributorParam = {
        location_id: stepschecked.length === 0 ? null : stepschecked.toString(),
        season_id: values.season_id === "All" ? null : values.season_id,
        sku: values.sku ? values.sku : null,
        gender_id: values.gender === "All" ? null : values.gender,
        gender_category_id: null,
        style: styleId ? styleId.style_id : null,
        product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
        pending_date: moment(values.pending_date).format("YYYY-MM-DD"),
        customer_name: values.customer_id === "All" ? null : values.customer_id,
        term_name: values.term_id === "All" ? null : values.term_id,
        salesperson_name:
          values.sale_person === "All" ? null : values.sale_person,
      };
      setLoading(true);
      dispatch(getNegativeOtsOrderWise(token, distributorParam)).then((res) => {
        setLoading(false);
        setStockWiseReport(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    });
  };

  const downLoadExcel = (values) => {
    setLoadding(true);
    values.BGradeStock = BGradechecked;
    values.stepsChecked = stepsChecked;
    values.isChecked = isChecked;
    values.isChecked2 = isChecked2;
    if (allStatus) {
      values.allStatus = allStatus;
    }
    if (pendingChecked) {
      stepschecked.push(-1);
    }
    const styleId =
      style &&
      style?.payload?.data.find((val) => val.style_name === values.style);

    const productStatusId =
      productStatus &&
      productStatus?.payload?.data.find(
        (val) => val.product_status_name === values.product_Status
      );

    const distributorParam = {
      location_id: stepschecked.length === 0 ? null : stepschecked.toString(),
      season_id: values.season_id === "All" ? null : values.season_id,
      sku: values.sku ? values.sku : null,
      gender_category_id: values.type === "All" ? null : values.type,
      style: styleId ? styleId.style_id : null,
      product_status_id: isChecked2.length > 0 ? isChecked2.toString() : null,
      pending_date: moment(values.pending_date).format("YYYY-MM-DD"),
    };
    dispatch(getNegativeOtsOrderWise(token, distributorParam)).then((res) => {
      downloadExcelFileData(res?.payload?.data);
      if (buttonRef.current) {
        return buttonRef.current.link.click();
      }
    });
  };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          SKU: v.item_code,
          Style: v.style_name,
          Wash: v.description,
          Inseam: v.inseam,
          "Bulk Order": null,
          Location: v.location_name,
          "Ex-Factory Date": null,
          "Bergen In Dc Date": null,
          " 23 ": v.qty_1,
          " 24 ": v.qty_2,
          " 25 ": v.qty_3,
          " 26 ": v.qty_4,
          " 27 ": v.qty_5,
          " 28 ": v.qty_6,
          " 29 ": v.qty_7,
          " 30 ": v.qty_8,
          " 31 ": v.qty_9,
          " 32 ": v.qty_10,
          " 33 ": v.qty_11,
          " 34 ": v.qty_12,
          " 35 ": v.qty_13,
          " 36 ": v.qty_14,
          " 37 ": v.qty_15,
          " 38 ": v.qty_16,
          Quantity: v.sum_quantity,
        };
      })
    );
    setLoadding(false);
  }

  let sumQuantity;

  useEffect(() => {
    dispatch(getStyle(token, menuId));
    dispatch(getProductType(token, menuId));
    dispatch(getSeason(token, menuId));
    dispatch(getGenderCategory(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getNewSeason(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
    dispatch(getProductStatus(token, menuId));
    dispatch(getAdminLocation(token, menuId));
    dispatch(loadSalePerson(token));
  }, [dispatch, menuId, token]);

  useEffect(() => {
    if (allSesion) {
      setIsChecked([]);
    }
  }, [allSesion]);

  useEffect(() => {
    if (allStatus) {
      setIsChecked2([]);
    }
  }, [allStatus]);

  const handlePrint = () => {
    window.print();
  };

  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(
      loadCustomers(
        token,
        null,
        null,
        null,
        null,
        null,
        val,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      )
    ).then((res) => {
      if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
        setCustomer(res?.payload?.data);
      }
    });
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);

  return (
    <div
      className="distributor header_class stock_style_wise"
      style={{ width: "1500px" }}
    >
      <div
        className="row justify-content-between distributr"
        style={{ width: "1200px", margin: "0 auto" }}
      >
        {/**** / Logo *****/}
        <div className="col-3 d-flex align-items-sm-center box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-3 box-space right-content-header text-sm-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8 printing_class">
              <div className="print_icon printing_class">
                <i
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  onClick={handlePrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div
                className="print_icon printing_class"
                name="ImgExcel"
                alt="Export to excel"
                id="ImgExcel"
                title="Export to excel"
                src={xlsx}
              >
                {/* <i className="fa-solid fa-file-excel"></i> */}

                {wiseStockReport ? (
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    onClick={onDownload}
                    style={{
                      borderWidth: "0px",
                      height: "14px",
                      cursor: "pointer",
                    }}
                  />
                ) : (
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                    style={{ borderWidth: "0px", height: "14px" }}
                  />
                )}
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Negative OTS Order Wise
              <br />
              Rpt # 489
              <br />
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
              {/* type="image"
              name="ImgExcel"
              alt="Export to excel"
              id="ImgExcel"
              title="Export to excel"
              src={xlsx}
              style={{ borderWidth: "0px", height: "20px" }}
            />  */}
            </span>
          </div>
        </div>
      </div>
      {/*  */}
      <div
        className="business_class_oms distributr"
        style={{ width: "1200px", margin: "0 auto" }}
      >
        {/* Table Selects */}
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className=" col-12 ">
              <hr className="mt-0 mb-2" />
              <div>
                <label htmlFor="">Product Status</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox checked={allStatus} onChange={statusSelectAll}>
                        All
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox
                        checked={allStatus ? false : isChecked2.includes(2)}
                        onChange={(e) =>
                          isCheckboxChecked2(2, e.target.checked)
                        }
                      >
                        Discontinued
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox
                        checked={allStatus ? false : isChecked2.includes(1)}
                        onChange={(e) =>
                          isCheckboxChecked2(1, e.target.checked)
                        }
                      >
                        Off Price
                      </Checkbox>
                    </Form.Item>
                  </div>
                  <div className="checkbox_content">
                    <Form.Item name="current_status_id" className=" mb-0">
                      <Checkbox
                        checked={allStatus ? false : isChecked2.includes(3)}
                        onChange={(e) =>
                          isCheckboxChecked2(3, e.target.checked)
                        }
                      >
                        Active Line
                      </Checkbox>
                    </Form.Item>
                  </div>
                  {/* {productStatus &&
                    productStatus?.payload?.data.map((it, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Form.Item name="current_status_id">
                            <Checkbox
                              checked={
                                allStatus
                                  ? false
                                  : isChecked2.includes(it.product_status_id)
                              }
                              onChange={(e) =>
                                isCheckboxChecked2(
                                  it.product_status_id,
                                  e.target.checked
                                )
                              }
                            >
                              {it.product_status_name}
                            </Checkbox>
                          </Form.Item>
                        </div>
                      );
                    })} */}
                </div>
              </div>
              {/* <div>
                <label>Season</label>
                <div className="checkboxes">
                  <div className="checkbox_content">
                    <Checkbox
                      size="large"
                      checked={allSesion}
                      onChange={sesionSelectAll}
                    >
                      All
                    </Checkbox>
                  </div>
                  {getNewSeasonReducer &&
                    getNewSeasonReducer?.payload?.data.map((session, index) => {
                      return (
                        <div key={index} className="checkbox_content">
                          <Checkbox
                            size="large"
                            checked={allSesion ? false : isChecked.includes(session.season_id)}
                            
                            
                            onChange={(e) =>
                              isCheckboxChecked(
                                session.season_id,
                                e.target.checked
                              )
                            }
                          
                          
                          
                          
                          
                          
                          
                          
                          >
                            {session.season_name}
                          </Checkbox>
                        </div>
                      );
                    })}
                </div>
              </div> */}
              <hr className="my-1" />
              <div>
                <label>Steps</label>
                <div className="checkboxes">
                  {getStepData &&
                    getStepData.map((step, i) => {
                      return (
                        <div className="checkbox_content">
                          <Checkbox
                            checked={steps[i]?.selected}
                            value={12}
                            onChange={(e) => {
                              setSteps(
                                steps.map((it) => {
                                  if (it.location_id == step.location_id) {
                                    return {
                                      ...it,
                                      selected: e.target.checked,
                                    };
                                  } else {
                                    return it;
                                  }
                                })
                              );
                            }}
                          >
                            {step.location_name}
                          </Checkbox>
                        </div>
                      );
                    })}
                  <Checkbox
                    checked={pendingChecked}
                    onChange={handlePendingOrder}
                  >
                    Pending Order
                  </Checkbox>
                </div>
              </div>
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">
                      Season
                    </label>
                    <div className="w-100">
                      <Form.Item name="season_id" initialValue={"All"}>
                        <Select
                          defaultValue={form.getFieldValue().season_id}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                        >
                          <Option value={null}>All</Option>
                          {season &&
                            season?.payload?.data?.map((status, index) => {
                              return (
                                <Option key={index} value={status.season_id}>
                                  {status.season_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* Second */}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Gender</label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="gender">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          <Option value={null}>All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* Third */}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Style</label>
                    <div className="w-100">
                      <Form.Item initialValue={"All"} name="style">
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                        >
                          <Option value={null}>All</Option>
                          {style &&
                            style?.payload?.data.map((style, index) => {
                              return (
                                <Option key={index} value={style.style_name}>
                                  {style.style_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* Fourth */}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Sku</label>
                    <div className="w-100">
                      <Form.Item name="sku" className="sku_input">
                        <Input size="small" className={"select_Inputs mb-0"} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Pending till</label>
                    <div className="w-100">
                      <Form.Item
                        name="pending_date"
                        className="full_date "
                        initialValue={initialDate}
                      >
                        <DatePicker
                          format={dateFormatList}
                          size="small"
                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/* <div className=" col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Customer:</label>
                    <div className=" w-100">
                      <Form.Item name="customer_id" initialValue={"All"}>
                        <Select
                          showSearch
                          optionFilterProp="children"
                          className={"select_Inputs"}
                          loading={customerForms.loading}
                          size="small"
                          onSearch={(value) => {
                            optimizedFn(value);
                          }}
                          ref={focusInput}
                          value={customer}
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {customerForms?.payload?.data.map((item) => {
                            return (
                              <Option key={item.customer_id}>
                                {`${item.customer_name}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className=" col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Payment Term:</label>
                    <div className=" w-100">
                      <Form.Item name="term_id" initialValue={"All"}>
                        <Select
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          showSearch
                          defaultValue={form.getFieldValue().term_id}
                          size="small"
                          className={"input-width"}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== "All"
                              ? optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                        >
                          <Option value="All">All</Option>
                          {paymentterm?.payload?.data.map((item) => {
                            return (
                              <Option
                                defaultValue={"All"}
                                key={item.term_id}
                                value={item.term_id}
                              >
                                {item.term_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className=" col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">Sale Person:</label>
                    <div className=" w-100">
                      <Form.Item name="sale_person" initialValue={"All"}>
                        <Select
                          size="small"
                          showSearch
                          optionFilterProp="children"
                          filterOption={(input, options) =>
                            options.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                          className="styleInput w-100"
                          defaultValue={form.getFieldValue().sale_person}
                          filterSort={(optionA, optionB) =>
                            optionB?.value !== null
                              ? optionA.children
                                  .toLowerCase()
                                  .localeCompare(optionB.children.toLowerCase())
                              : ""
                          }
                        >
                          <Option value={null}>All</Option>
                          {salePersonForm?.payload?.data.map((val, index) => {
                            return (
                              <Option
                                key={val.sales_person_id}
                                value={val.sales_person_id}
                              >
                                {val.salesperson_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div> */}
                <div
                  // className="main_form row"
                  className="col-12 col-md-3"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    float: "right",
                  }}
                >
                  <div className="col-12 col-md-3">
                    <div className=" d-flex flex-row align-items-baseline">
                      {/* <label 

                      className=" no_visibility"
                      style={{ marginBottom: "3px" }}
                    >
                      none
                    </label> */}
                      <div
                        style={{
                          marginTop: "4px",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        {!loading ? (
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="submit-btn-btm m-0"
                          >
                            Generate
                          </Button>
                        ) : (
                          <Spin size="medium" />
                        )}
                        {/* <div style={{ display: "flex" }}>
                        <label className="no_visibility">none</label>
                        <div
                          style={{
                            display: "none",
                          }}
                        >
                          <CSVLink
                            className="submit-btn-btm m-0"
                            ref={buttonRef}
                            filename={"Stock-Style-Wise.csv"}
                            data={excelData}
                          >
                            Download Excel
                          </CSVLink>
                        </div>
                        {!loadding ?
                          <Button
                            type="primary"
                            className="submit-btn-btm m-0"
                            onClick={() => downLoadExcel(form.getFieldValue())}
                          >
                            Generate Excel
                          </Button> : <Spin size="medium" />}
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
        {/* <div
          style={{
            display: "none",
          }}
        >
          <CSVLink
            className="submit-btn-btm m-0"
            ref={buttonRef}
            filename={"Stock-Style-Wise.csv"}
            data={excelData}
          >
            Download Excel
          </CSVLink>
        </div>
        <Button
          type="primary"
          className="submit-btn-btm m-0"
          onClick={() => downLoadExcel(form.getFieldValue())}
        >
          {!loadding ? "Generate Excel" : <Loader className="spinner" />}
        </Button> */}
        { }
        {/* {excelData?.length > 0 ? (
          <div className="loader" style={{ marginTop: "20px" }}>
            <Spin size="medium" />
          </div>
        ) : null} */}
      </div>
      {/* Table  Data */}

      <div
        className="business_class_oms"
        style={{ width: "1500px", overflowX: "auto" }}
        ref={tableRef}
      >
        {wiseStockReport ? (
          wiseStockReport.length > 0 ? (
            wiseStockReport.map((data, index) => {
              console.log({ data });
              const sizes = data;

              let qty1 = null;
              let qty2 = null;
              let qty3 = null;
              let qty4 = null;
              let qty5 = null;
              let qty6 = null;
              let qty7 = null;
              let qty8 = null;
              let qty9 = null;
              let qty10 = null;
              let qty11 = null;
              let qty12 = null;
              let qty13 = null;
              let qty14 = null;
              let qty15 = null;
              let qty16 = null;
              let sqty1 = null;
              let sqty2 = null;
              let sqty3 = null;
              let sqty4 = null;
              let sqty5 = null;
              let sqty6 = null;
              let sqty7 = null;
              let sqty8 = null;
              let sqty9 = null;
              let sqty10 = null;
              let sqty11 = null;
              let sqty12 = null;
              let sqty13 = null;
              let sqty14 = null;
              let sqty15 = null;
              let sqty16 = null;

              for (let i = 0; i < data.length; i++) {
                qty1 += parseInt(data[i].qty_1);
                qty2 += parseInt(data[i].qty_2);
                qty3 += parseInt(data[i].qty_3);
                qty4 += parseInt(data[i].qty_4);
                qty5 += parseInt(data[i].qty_5);
                qty6 += parseInt(data[i].qty_6);
                qty7 += parseInt(data[i].qty_7);
                qty8 += parseInt(data[i].qty_8);
                qty9 += parseInt(data[i].qty_9);
                qty10 += parseInt(data[i].qty_10);
                qty11 += parseInt(data[i].qty_11);
                qty12 += parseInt(data[i].qty_12);
                qty13 += parseInt(data[i].qty_13);
                qty14 += parseInt(data[i].qty_14);
                qty15 += parseInt(data[i].qty_15);
                qty16 += parseInt(data[i].qty_16);
                sqty1 += parseInt(data[i].qty_1);
                sqty2 += parseInt(data[i].qty_2);
                sqty3 += parseInt(data[i].qty_3);
                sqty4 += parseInt(data[i].qty_4);
                sqty5 += parseInt(data[i].qty_5);
                sqty6 += parseInt(data[i].qty_6);
                sqty7 += parseInt(data[i].qty_7);
                sqty8 += parseInt(data[i].qty_8);
                sqty9 += parseInt(data[i].qty_9);
                sqty10 += parseInt(data[i].qty_10);
                sqty11 += parseInt(data[i].qty_11);
                sqty12 += parseInt(data[i].qty_12);
                sqty13 += parseInt(data[i].qty_13);
                sqty14 += parseInt(data[i].qty_14);
                sqty15 += parseInt(data[i].qty_15);
                sqty16 += parseInt(data[i].qty_16);
              }

              let sumQ = 0;

              for (let i = 0; i < data.length; i++) {
                sumQ += parseInt(data[i].sum_quantity);
              }

              return (
                <div key={index} style={{ width: "2400px" }}>
                  <div className="table_data-Heading distributr">
                    {data[0].item_code} - {data[0].description}
                  </div>
                  <table className="table_distributor-data distributr">
                    <tbody>
                      <tr className=" font_weight">
                        <td className="font-weig" style={{ width: "20px" }}>
                          #
                        </td>
                        <td
                          style={{ width: "55px", fontWeight: "800" }}
                          className="font-weig"
                        >
                          SKU
                        </td>
                        <td className="font-weig" style={{ width: "50px", fontWeight: "800" }}>
                          Inseam
                        </td>
                        <td className="font-weig" style={{ width: "140px", fontWeight: "800" }}>
                          Style
                        </td>
                        <td className="font-weig" style={{ width: "120px", fontWeight: "800" }}>
                          Wash
                        </td>
                        <td className="font-weig" style={{ width: "120px", fontWeight: "800" }}>Gender</td>
                        <td className="font-weig" style={{ width: "120px", fontWeight: "800" }}>Status</td>
                        <td className="font-weig" style={{ width: "120px", fontWeight: "800" }}>Season</td>
                        <td className="font-weig" style={{ width: "130px", fontWeight: "800" }}>
                          Location
                        </td>
                        <td className="font-weig" style={{ width: "140px", fontWeight: "800" }}>
                          Revised Ex-Factory Date
                        </td>
                        <td className="font-weig" style={{ width: "110px", fontWeight: "800" }}>
                          Bergen In Dc Date
                        </td>
                        <td
                          style={{ width: "20px", textAlign: "right", fontWeight: "800" }}
                          className="font-weig"
                        >
                          {sizes[0].size_1}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_2}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_3}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_4}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_5}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_6}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_7}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_8}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_9}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_10}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_11}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_12}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_13}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_14}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_15}
                        </td>
                        <td
                          style={{
                            width: "20px",
                            textAlign: "right",
                            paddingRight: "2px",
                            fontWeight: "800"
                          }}
                          className="font-weig"
                        >
                          {sizes[0].size_16}
                        </td>
                        <td
                          className="font-weig"
                          style={{ textAlign: "right", width: "60px", fontWeight: "800" }}
                        >
                          Quantity
                        </td>
                        <td className="font-weig" style={{ width: "60px", fontWeight: "800" }}>
                          Order no
                        </td>
                        <td className="font-weig" style={{ width: "70px", fontWeight: "800" }}>
                          Order Date
                        </td>
                        <td className="font-weig" style={{ width: "70px", fontWeight: "800" }}>
                          Start Date
                        </td>
                        <td className="font-weig" style={{ width: "70px", fontWeight: "800" }}>
                          Cancel Date
                        </td>
                        <td className="font-weig" style={{ fontWeight: "800" }}>Customer</td>
                        <td className="font-weig" style={{ fontWeight: "800" }}>PO #</td>
                        <td className="font-weig" style={{ fontWeight: "800" }}>SalesPerson</td>
                        <td className="font-weig" style={{ fontWeight: "800" }}>Order Gender</td>
                        <td className="font-weig" style={{ fontWeight: "800" }}>Term</td>
                      </tr>
                      {data.map((values, index) => {
                        console.log({ values });
                        const filterQuantity = data.filter(
                          (val) =>
                            val.location_id === values.location_id &&
                            val.seq === values.seq
                        );

                        const totalQuantity = filterQuantity.map((qty) => {
                          return (
                            Number(qty.qty_1) +
                            Number(qty.qty_2) +
                            Number(qty.qty_3) +
                            Number(qty.qty_4) +
                            Number(qty.qty_5) +
                            Number(qty.qty_6) +
                            Number(qty.qty_7) +
                            Number(qty.qty_8) +
                            Number(qty.qty_9) +
                            Number(qty.qty_10) +
                            Number(qty.qty_11) +
                            Number(qty.qty_12) +
                            Number(qty.qty_13) +
                            Number(qty.qty_14) +
                            Number(qty.qty_15) +
                            Number(qty.qty_16)
                          );
                        });

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{values.item_code}</td>
                            <td>{values.inseam}</td>
                            <td>{values.style_name}</td>
                            <td>{values.description}</td>
                            <td>{values.product_gender}</td>
                            <td>{values.product_status_name}</td>
                            <td>{values.season_name}</td>
                            <td>{values.location_name}</td>
                            {/* <td>{(values.location_name == 'In Transit' || values.location_name == 'PK Warehouse' || values.location_name == 'Production') && (moment().format("MM-DD-YYYY") !== moment(values.ex_factory_date).format("MM-DD-YYYY")) ? moment(values.ex_factory_date).format("MM-DD-YYYY") : <></>}</td>
                            <td>{(values.location_name == 'In Transit' || values.location_name == 'PK Warehouse' || values.location_name == 'Production') && (moment().format("MM-DD-YYYY") !== moment(values.burgen_indc_date).format("MM-DD-YYYY")) ? moment(values.burgen_indc_date).format("MM-DD-YYYY") : <></>}</td> */}
                            <td>
                              {moment(values.ex_factory_date).format(
                                "MM-DD-YYYY"
                              ) === "01-01-2000" ||
                                moment(values.ex_factory_date).format(
                                  "MM-DD-YYYY"
                                ) === "12-31-1999"
                                ? null
                                : moment(values.ex_factory_date).format(
                                  "MM-DD-YYYY"
                                )}
                            </td>
                            <td>
                              {moment(values.burgen_indc_date).format(
                                "MM-DD-YYYY"
                              ) === "01-01-2000" ||
                                moment(values.burgen_indc_date).format(
                                  "MM-DD-YYYY"
                                ) === "12-31-1999"
                                ? null
                                : moment(values.burgen_indc_date).format(
                                  "MM-DD-YYYY"
                                )}
                            </td>
                            {/* <td>{(values.location_name === "Production" || values.location_name === "In Transit")  ? (moment(values.ex_factory_date).format("MM-DD-YYYY")) : null}</td>
                            <td>{(values.location_name === "Production" || values.location_name === "In Transit")  ? moment(values.burgen_indc_date).format("MM-DD-YYYY") : null}</td> */}
                            {filterQuantity.map((quan, index) => {
                              sumQuantity =
                                Number(quan.qty_1) +
                                Number(quan.qty_2) +
                                Number(quan.qty_3) +
                                Number(quan.qty_4) +
                                Number(quan.qty_5) +
                                Number(quan.qty_6) +
                                Number(quan.qty_7) +
                                Number(quan.qty_8) +
                                Number(quan.qty_9) +
                                Number(quan.qty_10) +
                                Number(quan.qty_11) +
                                Number(quan.qty_12) +
                                Number(quan.qty_13) +
                                Number(quan.qty_14) +
                                Number(quan.qty_15) +
                                Number(quan.qty_16);

                              sqty1 =
                                quan.qty_1 < 0 && sqty1 <= 0
                                  ? sqty1 - quan.qty_1
                                  :
                                  quan.qty_1 < 0 && sqty1 >= 0
                                    ? NaN
                                    : sqty1;
                              sqty2 =
                                quan.qty_2 < 0 && sqty2 <= 0
                                  ? sqty2 - quan.qty_2
                                  :
                                  quan.qty_2 < 0 && sqty2 >= 0
                                    ? NaN
                                    : sqty2;
                              sqty3 =
                                quan.qty_3 < 0 && sqty3 <= 0
                                  ? sqty3 - quan.qty_3
                                  :
                                  quan.qty_3 < 0 && sqty3 >= 0
                                    ? NaN
                                    : sqty3;
                              sqty4 =
                                quan.qty_4 < 0 && sqty4 <= 0
                                  ? sqty4 - quan.qty_4
                                  :
                                  quan.qty_4 < 0 && sqty4 >= 0
                                    ? NaN
                                    : sqty4;
                              sqty5 =
                                quan.qty_5 < 0 && sqty5 <= 0
                                  ? sqty5 - quan.qty_5
                                  :
                                  quan.qty_5 < 0 && sqty5 >= 0
                                    ? NaN
                                    : sqty5;
                              sqty6 =
                                quan.qty_6 < 0 && sqty6 <= 0
                                  ? sqty6 - quan.qty_6
                                  :
                                  quan.qty_6 < 0 && sqty6 >= 0
                                    ? NaN
                                    : sqty6;
                              sqty7 =
                                quan.qty_7 < 0 && sqty7 <= 0
                                  ? sqty7 - quan.qty_7
                                  :
                                  quan.qty_7 < 0 && sqty7 >= 0
                                    ? NaN
                                    : sqty7;
                              sqty8 =
                                quan.qty_8 < 0 && sqty8 <= 0
                                  ? sqty8 - quan.qty_8
                                  :
                                  quan.qty_8 < 0 && sqty8 >= 0
                                    ? NaN
                                    : sqty8;
                              sqty9 =
                                quan.qty_9 < 0 && sqty9 <= 0
                                  ? sqty9 - quan.qty_9
                                  :
                                  quan.qty_9 < 0 && sqty9 >= 0
                                    ? NaN
                                    : sqty9;
                              sqty10 =
                                quan.qty_10 < 0 && sqty10 <= 0
                                  ? sqty10 - quan.qty_10
                                  :
                                  quan.qty_10 < 0 && sqty10 >= 0
                                    ? NaN
                                    : sqty10;
                              sqty11 =
                                quan.qty_11 < 0 && sqty11 <= 0
                                  ? sqty11 - quan.qty_11
                                  :
                                  quan.qty_11 < 0 && sqty11 >= 0
                                    ? NaN
                                    : sqty11;
                              sqty12 =
                                quan.qty_12 < 0 && sqty12 <= 0
                                  ? sqty12 - quan.qty_12
                                  :
                                  quan.qty_12 < 0 && sqty12 >= 0
                                    ? NaN
                                    : sqty12;
                              sqty13 =
                                quan.qty_13 < 0 && sqty13 <= 0
                                  ? sqty13 - quan.qty_13
                                  :
                                  quan.qty_13 < 0 && sqty13 >= 0
                                    ? NaN
                                    : sqty13;
                              sqty14 =
                                quan.qty_14 < 0 && sqty14 <= 0
                                  ? sqty14 - quan.qty_14
                                  :
                                  quan.qty_14 < 0 && sqty14 >= 0
                                    ? NaN
                                    : sqty14;
                              sqty15 =
                                quan.qty_15 < 0 && sqty15 <= 0
                                  ? sqty15 - quan.qty_15
                                  :
                                  quan.qty_15 < 0 && sqty15 >= 0
                                    ? NaN
                                    : sqty15;
                              sqty16 =
                                quan.qty_16 < 0 && sqty16 <= 0
                                  ? sqty16 - quan.qty_16
                                  :
                                  quan.qty_16 < 0 && sqty16 >= 0
                                    ? NaN
                                    : sqty16;


                              console.log(quan.qty_3, sqty3, 'qqq',);

                              return (
                                <>
                                  {quan.qty_1 && (
                                    <td
                                      key={index}
                                      style={{
                                        color:
                                          quan.qty_1 < 0 && sqty1 <= 0
                                            ? "red"
                                            : "black",
                                        textAlign: "right",
                                        paddingRight: "2px",
                                      }}
                                    >
                                      {quan.qty_1}
                                      <span style={{ color: 'red', marginLeft: '2px' }}>{
                                        (
                                          quan.qty_1 < 0
                                          && sqty1 > 0
                                          && qty1 < 0
                                          && (Number(quan.qty_1) + Number(sqty1)) < 0
                                        )
                                        && ('(' + (Number(quan.qty_1) + Number(sqty1)) + ')')}
                                      </span>
                                    </td>
                                  )}
                                  <td
                                    style={{
                                      color:
                                        quan.qty_2 < 0 && sqty2 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_2}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_2 < 0
                                        && sqty2 > 0
                                        && qty2 < 0
                                        && (Number(quan.qty_2) + Number(sqty2)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_2) + Number(sqty2)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_3 < 0 && sqty3 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_3}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_3 < 0
                                        && sqty3 > 0
                                        && qty3 < 0
                                        && (Number(sqty3) + Number(quan.qty_3)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_3) + Number(sqty3)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_4 < 0 && sqty4 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_4}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_4 < 0
                                        && sqty4 > 0
                                        && qty4 < 0
                                        && (Number(quan.qty_4) + Number(sqty4)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_4) + Number(sqty4)) + ')')}
                                    </span>

                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_5 < 0 && sqty5 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_5}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_5 < 0
                                        && sqty5 > 0
                                        && qty5 < 0
                                        && (Number(sqty5) + Number(quan.qty_5)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_5) + Number(sqty5)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_6 < 0 && sqty6 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_6}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_6 < 0
                                        && sqty6 > 0
                                        && qty6 < 0
                                        && (Number(sqty6) + Number(quan.qty_6)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_6) + Number(sqty6)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_7 < 0 && sqty7 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_7}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_7 < 0
                                        && sqty7 > 0
                                        && qty7 < 0
                                        && (Number(sqty7) + Number(quan.qty_7)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_7) + Number(sqty7)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_8 < 0 && sqty8 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_8}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_8 < 0
                                        && sqty8 > 0
                                        && qty8 < 0
                                        && (Number(sqty8) + Number(quan.qty_8)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_8) + Number(sqty8)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_9 < 0 && sqty9 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_9}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_9 < 0
                                        && sqty9 > 0
                                        && qty9 < 0
                                        && (Number(sqty9) + Number(quan.qty_9)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_9) + Number(sqty9)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_10 < 0 && sqty10 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_10}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_10 < 0
                                        && sqty10 > 0
                                        && qty10 < 0
                                        && (Number(sqty10) + Number(quan.qty_10)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_10) + Number(sqty10)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_11 < 0 && sqty11 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_11}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_11 < 0
                                        && sqty11 > 0
                                        && qty11 < 0
                                        && (Number(sqty11) + Number(quan.qty_11)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_11) + Number(sqty11)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_12 < 0 && sqty12 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_12}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_12 < 0
                                        && sqty12 > 0
                                        && qty12 < 0
                                        && (Number(sqty12) + Number(quan.qty_12)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_12) + Number(sqty12)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_13 < 0 && sqty13 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_13}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_13 < 0
                                        && sqty13 > 0
                                        && qty13 < 0
                                        && (Number(sqty13) + Number(quan.qty_13)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_13) + Number(sqty13)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_14 < 0 && sqty14 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_14}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_14 < 0
                                        && sqty14 > 0
                                        && qty14 < 0
                                        && (Number(sqty14) + Number(quan.qty_14)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_14) + Number(sqty14)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_15 < 0 && sqty15 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_15}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_15 < 0
                                        && sqty15 > 0
                                        && qty15 < 0
                                        && (Number(sqty15) + Number(quan.qty_15)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_15) + Number(sqty15)) + ')')}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        quan.qty_16 < 0 && sqty16 <= 0
                                          ? "red"
                                          : "black",
                                      textAlign: "right",
                                      paddingRight: "2px",
                                    }}
                                  >
                                    {quan.qty_16}
                                    <span style={{ color: 'red', marginLeft: '2px' }}>{
                                      (
                                        quan.qty_16 < 0
                                        && sqty16 > 0
                                        && qty16 < 0
                                        && (Number(sqty16) + Number(quan.qty_16)) < 0
                                      )
                                      && ('(' + (Number(quan.qty_16) + Number(sqty16)) + ')')}
                                    </span>
                                  </td>
                                </>
                              );
                            })}
                            <td
                              style={{
                                textAlign: "right",
                                paddingRight: "2px",
                              }}
                            >
                              {totalQuantity.toString()}
                            </td>
                            <td>
                              {values.order_no === 0 ? null : values.order_no}
                            </td>
                            <td>
                              {values.order_date === null
                                ? null
                                : moment(values.order_date).format(
                                  "MM-DD-YYYY"
                                )}
                            </td>
                            <td>
                              {values.order_date === null
                                ? null
                                : moment(values.start_date).format(
                                  "MM-DD-YYYY"
                                )}
                            </td>
                            <td>
                              {values.order_date === null
                                ? null
                                : moment(values.end_date).format("MM-DD-YYYY")}
                            </td>
                            <td>{values.customer_name}</td>
                            <td>{values.reference_no}</td>
                            <td>{values.salesperson_name}</td>
                            <td>{values.gender_name}</td>
                            <td>{values.term_name}</td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="font-weig"></td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.item_code}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.inseam}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.style_name}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.description}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.product_gender}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.product_status_name}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>{data[0]?.season_name}</td>
                        <td className="font-weig" style={{ fontWeight: "800", fontWeight: "800" }}>Total OTS</td>
                        <td className="font-weig"></td>
                        <td className="font-weig"></td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty1 < 0 ? "red" : "black",
                            fontWeight: "800"

                          }}
                        >
                          {qty1 !== qty1 ? "" : qty1}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty2 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty2 !== qty2 ? "" : qty2}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty3 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty3 !== qty3 ? "" : qty3}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty4 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty4 !== qty4 ? "" : qty4}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty5 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty5 !== qty5 ? "" : qty5}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty6 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty6 !== qty6 ? "" : qty6}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty7 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty7 !== qty7 ? "" : qty7}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty8 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty8 !== qty8 ? "" : qty8}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty9 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty9 !== qty9 ? "" : qty9}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty10 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty10 !== qty10 ? "" : qty10}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty11 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty11 !== qty11 ? "" : qty11}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty12 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty12 !== qty12 ? "" : qty12}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty13 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty13 !== qty13 ? "" : qty13}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty14 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty14 !== qty14 ? "" : qty14}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty15 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty15 !== qty15 ? "" : qty15}
                        </td>
                        <td
                          className="font-weig"
                          style={{
                            textAlign: "right",
                            paddingRight: "2px",
                            color: qty16 < 0 ? "red" : "black",
                            fontWeight: "800"
                          }}
                        >
                          {qty16 !== qty16 ? "" : qty16}
                        </td>
                        <td
                          className="font-weig"
                          style={{ textAlign: "right", paddingRight: "2px", fontWeight: "800", color: sumQ < 0 ? "red" : "black", }}
                        >
                          {numeral(sumQ).format("0,00,0")}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              );
            })
          ) : (
            <div className="no-Data">
              <h1>No Data</h1>
            </div>
          )
        ) : (
          loading && (
            <div className="loader" style={{ marginTop: "20px" }}>
              <Spin size="medium" />
            </div>
          )
        )}
        { }
      </div>
    </div>
  );
};

export default NegativeOrderOtsWise2;
